import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useEventDetails } from './EventDetailsContext';

const EventDetailsDialogs: React.FC = () => {
  const {
    deleteDialogOpen,
    setDeleteDialogOpen,
    handleConfirmDelete,
    assignOpen,
    setAssignOpen,
    clientQuery,
    setClientQuery,
    filteredClients,
    selectedClientId,
    setSelectedClientId,
    clientUsers,
    savingAssignment,
    confirmAssign,
  } = useEventDetails();

  return (
    <>
      <Dialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Borrar evento</DialogTitle>
            <DialogDescription>
              Se eliminarán todos los usuarios, fotos, likes y configuraciones del evento. Esta acción no se puede deshacer.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
            <Button variant="destructive" onClick={() => { void handleConfirmDelete(); }}>Confirmar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={assignOpen} onOpenChange={setAssignOpen}>
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>Asignar cliente</DialogTitle>
            <DialogDescription>Seleccioná un cliente para asignar a este evento.</DialogDescription>
          </DialogHeader>

          <div className="space-y-3">
            <div className="relative">
              <input
                className="w-full rounded-md border border-slate-200 pl-3 pr-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Buscar por nombre o email..."
                value={clientQuery}
                onChange={(event) => setClientQuery(event.target.value)}
              />
            </div>

            <div className="max-h-64 overflow-y-auto border border-slate-100 rounded-md divide-y">
              {filteredClients.map((client) => {
                const userData = clientUsers.get(client.user_id);
                const displayName = userData?.display_name || client.name || client.email || 'Sin nombre';
                const emailDisplay = userData?.email || client.email || '';
                const avatarInitial = displayName.trim().charAt(0).toUpperCase() || '?';

                return (
                  <label key={client.id} className="flex items-center gap-3 p-2 cursor-pointer hover:bg-slate-50">
                    <input
                      type="radio"
                      name="client"
                      className="h-4 w-4"
                      checked={selectedClientId === client.id}
                      onChange={() => setSelectedClientId(client.id)}
                    />
                    <Avatar className="h-8 w-8">
                      <AvatarImage src={userData?.avatar_url || ''} />
                      <AvatarFallback>{avatarInitial}</AvatarFallback>
                    </Avatar>
                    <div className="flex-1">
                      <div className="font-medium text-slate-800 text-sm">{displayName}</div>
                      {emailDisplay && <div className="text-xs text-slate-400">{emailDisplay}</div>}
                    </div>
                  </label>
                );
              })}

              {filteredClients.length === 0 && (
                <div className="p-3 text-sm text-slate-500">No se encontraron clientes.</div>
              )}
            </div>
          </div>

          <DialogFooter className="mt-3">
            <Button variant="outline" onClick={() => setAssignOpen(false)}>Cancelar</Button>
            {selectedClientId && (
              <Button onClick={() => { void confirmAssign(); }} disabled={savingAssignment}>
                {savingAssignment ? 'Guardando…' : 'Confirmar'}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EventDetailsDialogs;
